import BasePartial from 'pages/base_partial'

class ExamplePartial extends BasePartial {
  setup () {

  }
}

export default ExamplePartial
